// extracted by mini-css-extract-plugin
export default {"statisticsrelationship":"StatisticsRelationship_statisticsrelationship__sT3gN","container":"StatisticsRelationship_container__dARHZ","row":"StatisticsRelationship_row__YQs8U"};